<mat-grid-list cols="8" rowHeight="100px">
  <mat-grid-tile
    [colspan]=2
    [rowspan]=1>
    <div class="left-align"><h1>Critical Date Form</h1></div>
  </mat-grid-tile>
  <mat-grid-tile
    [colspan]=6
    [rowspan]=1>
    <!-- <mat-chip-list>
    <mat-chip color="accent">Critical Date Expired</mat-chip>
    <mat-chip color="accent">Critical date soon</mat-chip>
    <mat-chip color="accent">Critical Date in stable condition</mat-chip>
  </mat-chip-list> -->
</mat-grid-tile>
<mat-grid-tile
  [colspan]=6
  [rowspan]=1>
  <div class="left-align">Master Critical Date</div>
</mat-grid-tile>
<mat-grid-tile
  [colspan]=2
  [rowspan]=1>
  <button mat-raised-button color="primary"
    [disabled]="false">
    Edit
  </button>
  &nbsp; <!-- Space character -->
  <!-- <button mat-raised-button color="primary"
  (click)="newContractForm()"
>New Critical Date</button> -->
</mat-grid-tile>
</mat-grid-list>

@if (waitingForServer) {
  <mat-progress-spinner>
  </mat-progress-spinner>
}

<form
  #vendorForm="ngForm"
  (ngSubmit)="onSubmit(vendorForm)">

  <button
    mat-raised-button color="primary"
    type="submit"
    >Update Critical Date
  </button>

  <!-- <app-entity-form-shell
  [(entityData)]="currentCriticalDate">
</app-entity-form-shell> -->





<mat-tab-group>
  <mat-tab label="Associated">
    <h3>Associated</h3>
    <table width="100%">
      <tr>
        <td width="15%">
          <mat-button-toggle-group
            [(value)] = "associatedGroupSelected"
            vertical="true"
            #group="matButtonToggleGroup"
            value="schedules">
            <mat-button-toggle value="contracts">
              Contracts
            </mat-button-toggle>
            <mat-button-toggle value="parties">
              Associated Parties
            </mat-button-toggle>
            <mat-button-toggle value="people">
              People
            </mat-button-toggle>
            <mat-button-toggle value="reports">
              Reports
            </mat-button-toggle>
          </mat-button-toggle-group>
        </td>
        <td>


          @if (associatedGroupSelected === 'contracts') {
            <div>
              Yup.  Coming soon.
            </div>
          }


          @if (associatedGroupSelected === 'people') {
            <app-people-connections
              [(selectedPeopleList)]="currentCriticalDate.people">
            </app-people-connections>
          }


          @if (associatedGroupSelected === 'parties') {
            <app-vendor-connections
              [(selectedVendorList)]="currentCriticalDate.vendors">
            </app-vendor-connections>
          }


          @if (associatedGroupSelected === 'baas') {
            <app-baa-connections
              [(selectedBaaList)]="currentCriticalDate.baas">
            </app-baa-connections>
          }

          @if (associatedGroupSelected === 'reports') {
            <app-entity-form-report
              >
            </app-entity-form-report>
          }


        </td>
      </table>





    </mat-tab>
    <mat-tab label="Details">

      <br>
        <mat-grid-list cols="4" rowHeight="100px">
          <mat-grid-tile
            [colspan]=1
            [rowspan]=1>
            <mat-form-field>
              <input
                matInput
                [readonly]="reviewer"
                placeholder="Entity"
                name="entity"
                value={{currentCriticalDate.entity}}
                >
            </mat-form-field>
          </mat-grid-tile>
          <mat-grid-tile
            [colspan]=1
            [rowspan]=1>
            <mat-form-field>
              <input
                matInput
                [readonly]="reviewer"
                placeholder="Field"
                name="field"
                value={{currentCriticalDate.field}}
                >
            </mat-form-field>
          </mat-grid-tile>
        </mat-grid-list>

      </mat-tab>
      <mat-tab label="Notes">
        Notes
        <br>
          <app-notes [(notes)]="currentCriticalDate.notes"></app-notes>
        </mat-tab>
        <mat-tab label="Description">
          Description

          <p-editor
            [(ngModel)]="currentCriticalDate.description"
            name="description"
            [style]="{'height':'320px'}">
          </p-editor>

        </mat-tab>
      </mat-tab-group>
